
export default {
  name: 'ComponentNavigation',
  components: {},
  props: {
    data: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: () => ({
    viewport: '',
    navbar: false,
    topZero: true
  }),
  computed: {
    logoIsWhite() {
      return Boolean(this.topZero && !this.navbar)
    },
    iconColor() {
      return this.topZero && !this.navbar ? '#fff' : '#174f78'
    },
    navigationItems() {
      if (this.data) {
        let data = JSON.parse(JSON.stringify(this.data))
        return data.top_level.map((item) => {
          item.hidden_lg = item.hidden_lg !== 'FALSE'
          item.children = []
          if (data[item.link_text.toLowerCase()]) {
            item.children = data[item.link_text.toLowerCase()]
          }
          return item
        })
      }
      return null
    }
  },
  watch: {
    $route() {
      if (this.$refs.navigationPopover) {
        this.$refs.navigationPopover.forEach((popoverItem) => {
          popoverItem.doClose()
        })
      }
      setTimeout(() => {
        this.initializeNavigation()
      }, 150)
    }
  },
  created() {},
  mounted() {
    this.initializeNavigation()
  },
  methods: {
    initializeNavigation() {
      this.navbar = false
      if (document.querySelectorAll('.header').length) {
        window.removeEventListener('scroll', this.setPositionState)
        window.addEventListener('scroll', this.setPositionState)
        this.setPositionState()
      } else {
        this.topZero = false
      }
      window.removeEventListener('resize', this.setViewport)
      window.addEventListener('resize', this.setViewport)
      this.setViewport()
    },
    setViewport() {
      var wiw = window.innerWidth
      if (wiw >= 1025) {
        this.viewport = 'lg'
      } else {
        this.viewport = 'xs'
      }
    },
    setPositionState() {
      if (process.browser && process.client) {
        this.topZero =
          window.pageYOffset <= 0 && document.querySelectorAll('.header').length
      }
    }
  }
}
